import { StoreState } from '../store.state'

export const getLoadingPendingList = (state: StoreState) => {
  return state.loading.pendingList
}
